import React from 'react';
import PropTypes from 'prop-types';

import playTestSoundButtonSelector from '../../../../selectors/testOverview/testComponents/hardwareAccessCheck/PlayTestSoundButtonSelector';
import { t } from '../../../../services/i18nService';
import { getA11yAttributesV2 } from '../../../../services/a11yIIBScreenReaderService';

import styles from '../../testOverview.scss';

class PurePlayTestSoundButton extends React.PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    static defaultProps = {
        disabled: false,
    };

    render() {
        const { disabled, label, onClick } = this.props;

        return (
            <button
                className={`${styles.button} btn`}
                disabled={disabled}
                onClick={onClick}
                {...getA11yAttributesV2({
                    'aria-label': t('hardwareAccessCheck.playTestSoundButtonAriaLabel'),
                })}
            >
                <i className="fa fa-music" aria-hidden />
                {` ${label}`}
            </button>
        );
    }
}

function PlayTestSoundButton(props) {
    const newProps = playTestSoundButtonSelector.computeProps();

    return <PurePlayTestSoundButton {...props} {...newProps} />;
}

export default PlayTestSoundButton;
